import React from 'react';
import styles from './ThreeDotLoader.module.css';

interface ThreeDotLoaderProps {
  className?: string;
}

const ThreeDotLoader: React.FC<ThreeDotLoaderProps> = ({ className }) => {
  return (
    <span className={`${styles.threeDotLoader} ${className || ''}`}>
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
    </span>
  );
};

export default ThreeDotLoader;
